import React from "react";
import classes from "./styles/style.module.css";
import AnimatedPageContainer from "../../assets/containers/AnimatedPageContainer";
import MainBannerImg from "../../assets/images/Roshana/mbannerImg.png";
import RoshanaButton from "./Button";

const RoshanaMoharam = () => {
  return (
    <AnimatedPageContainer>
      <div className="w-100">
        <div className={classes.mBanner}>
          <div className={classes.mbannerContainer}>
            <img
              src={MainBannerImg}
              className={classes.mBannerimg}
              alt="mainBannerImg"
            />
          </div>
          <div className={classes.mMainContent}>
            <div className="d-flex justify-content-center align-items-center">
              <div className={classes.firstTextContainer}>
                <p>به مناسبت</p>
                <p>ایام محرم حسینی</p>
                <p>همخوانی کتاب‌های</p>
              </div>
              <div className={classes.whiteCircle}>
                ویـــــــــــــــژۀ
                <br />
                خانواده‌ها
              </div>
            </div>
            <div className="d-flex justify-content-center align-items-center">
              <div className={classes.secondTextContainer}>
                <p>نامیراو</p>
                <p>والد سوم</p>
              </div>
              <div className={classes.whiteCircle}>
                با جوایز
                <br />
                نفیس
              </div>
            </div>
          </div>
          <RoshanaButton
            color={"red"}
            text={"ثبت‌نام"}
            handleClick={() =>
            (window.location.href =
              "/acessv3/check/?redirect=https://app.rahebehesht.com/?page_id=1981&topic=AllAccess&type=CodeMeli")
            }
            styles={{ width: "60%", marginBlock: "20px" }}
          />
        </div>
      </div>
    </AnimatedPageContainer>
  );
};

export default RoshanaMoharam;
